'use client';
import FaceBook from '@/components/icons/FaceBook';
import Phone from '@/components/icons/Phone';
import QuestionMarkCircle from '@/components/icons/QuestionMarkCircle';
import Link from 'next/link';
import ProfileDropdown from './ProfileDropdown';

const AccountSection = ({ isMobile = false }) => {
  const closeMenu = () => {
    const navList = document.getElementById('navbarSupportedContent');
    navList.classList.remove('show');
    const tooltipList = document.getElementsByClassName('tooltip');
    for (const tooltip of tooltipList) {
      tooltip.classList.remove('show');
    }
  };

  return (
    <div className="account-section d-flex justify-content-end flex-column flex-md-row align-items-start align-items-md-center navbar-nav">
      <div className="facebook nav-item w-100 justify-content-start">
        <a
          href="https://www.facebook.com/BINGOWENDAKE/"
          className={'icon-link text-decoration-none'}
          target={'_blank'}
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Facebook"
          onClick={closeMenu}
        >
          <FaceBook fillColor={'secondary'} className={'d-none d-md-block '} />
          <span className="d-md-none fs-3 text-decoration-none">Facebook</span>
        </a>
      </div>
      <div className="contact-us nav-item w-100 justify-content-start">
        <Link
          href={'/contact-us'}
          className={'icon-link text-decoration-none'}
          onClick={closeMenu}
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Contactez-nous"
        >
          <Phone fillColor={'secondary'} className={'d-none d-md-block'} />
          <span className="d-md-none fs-3 text-decoration-none">
            Contactez-nous
          </span>
        </Link>
      </div>
      <div className="FAQ nav-item w-100 justify-content-start">
        <Link
          href={'/faq'}
          className={'icon-link text-decoration-none '}
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Foire aux questions"
          onClick={closeMenu}
        >
          <QuestionMarkCircle
            fillColor={'secondary'}
            className={'d-none d-md-block'}
          />
          <span className="d-md-none fs-3 text-decoration-none">
            Foire aux questions
          </span>
        </Link>
      </div>
      {!isMobile && <ProfileDropdown />}
    </div>
  );
};

export default AccountSection;
